module.exports = __webpack_public_path__ + "static/media/collapse_icon.a6bd8f44.svg";